import { useState } from "react";
import {
  UpdateCommitmentCommentRequest,
  useRelationshipsRelationshipUpdateCommitmentCommentMutation,
} from "@/services/backend/relationships/api/service";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { Commitment } from "@/services/backend/relationships/types/relationship";
import { Textarea } from "@/shared/components/ui/textarea";

export function CommentCell({ commitment }: { commitment: Commitment }) {
  const [request, setRequest] = useState<UpdateCommitmentCommentRequest>({
    id: commitment.relationshipId,
    commitmentId: commitment.id,
    comment: commitment.comment,
  });
  const mutation =
    useRelationshipsRelationshipUpdateCommitmentCommentMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: commitment.relationshipId,
    commitmentId: commitment.id,
    comment: commitment.comment,
  });

  return (
    <Textarea
      className="block min-h-6 w-full px-2 py-0.5 text-sm"
      value={request.comment}
      onChange={(e) => setRequest({ ...request, comment: e.target.value })}
    />
  );
}
